var _a;

import { ConsoleApiName, ErrorSource, initConsoleObservable, isExperimentalFeatureEnabled } from '@datadog/browser-core';
import { StatusType } from '../../logger';
var LogStatusForApi = (_a = {}, _a[ConsoleApiName.log] = StatusType.info, _a[ConsoleApiName.debug] = StatusType.debug, _a[ConsoleApiName.info] = StatusType.info, _a[ConsoleApiName.warn] = StatusType.warn, _a[ConsoleApiName.error] = StatusType.error, _a);
export function startConsoleCollection(configuration, sender) {
  var consoleObservable = initConsoleObservable(configuration.forwardConsoleLogs);
  var consoleSubscription = consoleObservable.subscribe(reportConsoleLog);

  function reportConsoleLog(log) {
    var messageContext = {};

    if (log.api === ConsoleApiName.error) {
      messageContext = {
        error: {
          origin: ErrorSource.CONSOLE,
          stack: log.stack
        }
      };
    }

    if (isExperimentalFeatureEnabled('forward-logs')) {
      messageContext.origin = ErrorSource.CONSOLE;
    }

    sender.sendToHttp(log.message, messageContext, LogStatusForApi[log.api]);
  }

  return {
    stop: function stop() {
      consoleSubscription.unsubscribe();
    }
  };
}